// extracted by mini-css-extract-plugin
var _1 = "QbP4w";
var _2 = "JKuHj";
export { _1 as "active", _2 as "base" }
